import { Link } from "react-router-dom";
import Input from "./Input";
import Output from "./Output";
import { Helmet } from "react-helmet-async";
import switchImage from "../assets/switch.png";


function Home({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, langPairs, text }) {


    return (

        <>
            <Helmet>
                <title>Online fordító</title>
                <meta name='description' content="Ingyenes online fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Online fordító" />
                <link rel="canonical" href="https://online-fordito.hu" />
            </Helmet>
            <h1>Online fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
              
                    
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>



            <div className="links magyarrol">

            <h2>Magyarról az alábbi fordítók állnak rendelkezésre</h2>

                <ul>
                    {langPairs
                        .filter(item => item.name.startsWith("Magyar")) // Filter out items that start with "Magyar"
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map(item => (
                            <li key={item.url}>
                                <Link to={item.url}>{item.name}</Link>
                            </li>
                        ))}
                </ul>
            </div>
        </>

    )
}

export default Home;